import Vue from "vue";
import Vuex from "vuex";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    mobale: false,
    Waterquerylist: [],
    model: false,
    Billlist: [],
    ApplyforList: []
  },
  mutations: {
    edit(state: any) {
      state.mobale = !state.mobale
    },
    Waterquerylist(state: any, list: any) {
      state.Waterquerylist = list
    },
    Billmodel(state: any) {
      state.model = !state.model
    },
    Billlist(state: any, list: any) {
      state.Billlist = list
    },
    APPLYFORLIST(state: any, list: any) {
      state.ApplyforList = list
    }
  },
  actions: {}
});
